import * as React from "react";
import { Context } from "./_context";
export const DateStopIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 21h-2V3h2v18Zm-5.293-9.707a1 1 0 0 1 .068 1.338l-.068.076-4 4-1.414-1.414L11.586 13H4v-2h7.586L9.293 8.707l1.414-1.414 4 4Z", fill: "currentColor" }));
  return iconset[size];
};
DateStopIcon.iconId = "f7ky6n";
